var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel-info-box"},[_c('div',{staticClass:"panel-info-box-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }